module.exports = __webpack_public_path__ + "static/media/logo.57af95bc.svg";